// import React from "react";
// import { FiX, FiCheckCircle } from "react-icons/fi";
// import { formatMoneyByLanguage } from "../../helpers/money";
// import { useTranslation } from "react-i18next";

// const MAIN_COLOR = "rgb(29, 71, 127)";

// const CardPanel = ({
//   cart,
//   totalAmount,
//   cartSummary,
//   language = "tr",
//   onChangeQuantity,
//   mobile,
//   onClose,
//   onConfirmCart,
//   confirmLoading = false,
//   confirmError = "",
// }) => {
//   const { t } = useTranslation();

//   const lang = String(language || "tr")
//     .toLowerCase()
//     .replace("_", "-")
//     .trim()
//     .slice(0, 2);

//   return (
//     <div className="flex h-full flex-col overflow-hidden bg-white">
//       <div className="flex items-center justify-between border-b border-slate-200 px-4 py-4">
//         <h3 className="text-base font-semibold text-slate-800">
//           {lang === "fr"
//             ? "Panier"
//             : lang === "de"
//               ? "Warenkorb"
//               : lang === "nl"
//                 ? "Winkelwagen"
//                 : lang === "en"
//                   ? "Cart"
//                   : "Sepet"}
//         </h3>

//         {mobile && (
//           <button
//             type="button"
//             onClick={onClose}
//             className="inline-flex h-10 w-10 shrink-0 items-center justify-center rounded-full border border-slate-200 bg-white text-slate-600 hover:bg-slate-50"
//           >
//             <FiX size={18} />
//           </button>
//         )}
//       </div>

//       <div className="flex-1 overflow-y-auto bg-slate-50 p-3">
//         {cart.length === 0 ? (
//           <div className="rounded-xl border border-dashed border-slate-300 bg-white p-6 text-center text-sm text-slate-500">
//             {lang === "fr"
//               ? "Votre panier est vide"
//               : lang === "de"
//                 ? "Ihr Warenkorb ist leer"
//                 : lang === "nl"
//                   ? "Uw winkelwagen is leeg"
//                   : lang === "en"
//                     ? "Your cart is empty"
//                     : "Sepetinizde henüz ürün yok"}
//           </div>
//         ) : (
//           <div className="space-y-3">
//             {cart.map((item) => (
//               <div
//                 key={item.code || item.id}
//                 className="rounded-xl border border-slate-200 bg-white p-3 shadow-sm"
//               >
//                 <div className="flex items-start gap-3">
//                   <div className="flex h-16 w-16 shrink-0 items-center justify-center rounded-lg border border-slate-200 bg-slate-50">
//                     {item.image ? (
//                       <img
//                         src={item.image}
//                         alt={item.name}
//                         className="max-h-14 max-w-14 object-contain"
//                       />
//                     ) : (
//                       <div className="text-[10px] text-slate-400">No Img</div>
//                     )}
//                   </div>

//                   <div className="min-w-0 flex-1">
//                     <div className="line-clamp-2 text-sm font-semibold text-slate-800">
//                       {item.name}
//                     </div>

//                     <div className="mt-1 text-xs text-slate-500">
//                       {formatMoneyByLanguage(item.unitPrice, lang)}
//                     </div>

//                     <div className="mt-3 flex items-center justify-between gap-3">
//                       <div className="flex items-center overflow-hidden rounded-lg border border-slate-300 bg-slate-100">
//                         <button
//                           onClick={() => onChangeQuantity(item, "decrease")}
//                           className="flex h-8 w-8 items-center justify-center font-bold hover:bg-slate-200"
//                         >
//                           -
//                         </button>

//                         <div className="w-10 border-x bg-white text-center">
//                           {item.quantity}
//                         </div>

//                         <button
//                           onClick={() => onChangeQuantity(item, "increase")}
//                           className="flex h-8 w-8 items-center justify-center font-bold hover:bg-slate-200"
//                         >
//                           +
//                         </button>
//                       </div>

//                       <div className="text-right text-sm font-bold text-slate-800">
//                         {formatMoneyByLanguage(
//                           item.unitPrice * item.quantity,
//                           lang
//                         )}
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             ))}
//           </div>
//         )}
//       </div>

//       <div className="border-t border-slate-200 bg-white p-4">
//         <div className="mb-3 rounded-xl bg-slate-100 px-3 py-3">
//           <div className="flex items-center justify-between py-1">
//             <span className="text-sm text-slate-600">
//               {lang === "fr"
//                 ? "Total (Hors Taxes)"
//                 : lang === "de"
//                   ? "Gesamt (ohne MwSt.)"
//                   : lang === "nl"
//                     ? "Totaal (excl. btw)"
//                     : lang === "en"
//                       ? "Total (Excl. VAT)"
//                       : "Toplam (KDV hariç)"}
//             </span>
//             <span className="text-sm font-semibold">
//               {formatMoneyByLanguage(cartSummary?.totalExclTax ?? 0, lang)}
//             </span>
//           </div>

//           <div className="flex items-center justify-between border-t py-2">
//             <span className="text-sm text-slate-600">
//               {lang === "fr"
//                 ? "Total TVA"
//                 : lang === "de"
//                   ? "MwSt. Gesamt"
//                   : lang === "nl"
//                     ? "Totaal btw"
//                     : lang === "en"
//                       ? "Total VAT"
//                       : "Toplam KDV"}
//             </span>
//             <span className="text-sm font-semibold">
//               {formatMoneyByLanguage(cartSummary?.totalTax ?? 0, lang)}
//             </span>
//           </div>

//           <div className="flex items-center justify-between border-t pt-2">
//             <span className="text-sm font-semibold">
//               {lang === "fr"
//                 ? "Total à Payer"
//                 : lang === "de"
//                   ? "Zu zahlender Gesamtbetrag"
//                   : lang === "nl"
//                     ? "Totaal te betalen"
//                     : lang === "en"
//                       ? "Total Payable"
//                       : "Ödenecek Toplam"}
//             </span>

//             <span className="text-base font-bold" style={{ color: MAIN_COLOR }}>
//               {formatMoneyByLanguage(
//                 cartSummary?.totalToPay ?? totalAmount ?? 0,
//                 lang
//               )}
//             </span>
//           </div>
//         </div>

//         {confirmError && (
//           <div className="mb-3 rounded-lg border border-red-200 bg-red-50 px-3 py-2 text-xs text-red-700">
//             {confirmError}
//           </div>
//         )}

//         <button
//           onClick={onConfirmCart}
//           disabled={cart.length === 0 || confirmLoading}
//           className="flex h-11 w-full items-center justify-center gap-2 rounded-xl font-semibold text-white disabled:opacity-50"
//           style={{ backgroundColor: MAIN_COLOR }}
//         >
//           <FiCheckCircle size={18} />
//           {confirmLoading
//             ? "Loading..."
//             : lang === "fr"
//               ? "Confirmer le panier"
//               : lang === "de"
//                 ? "Warenkorb bestätigen"
//                 : lang === "nl"
//                   ? "Winkelwagen bevestigen"
//                   : lang === "en"
//                     ? "Confirm Cart"
//                     : "Sepeti Onayla"}
//         </button>
//       </div>
//     </div>
//   );
// };

// export default CardPanel;

import React from "react";
import { FiX, FiCheckCircle } from "react-icons/fi";
import { formatMoneyByLanguage } from "../../helpers/money";

const MAIN_COLOR = "rgb(29, 71, 127)";

const TEXTS = {
  tr: {
    cart: "Sepet",
    emptyCart: "Sepetinizde henüz ürün yok",
    remove: "Kaldır",
    monthlyCredit: "Kontör / Ay",
    ioCredit: "Giden ve Gelen Fatura Kontörü",
    oCredit: "Giden Fatura Kontörü • Gelen Faturalar Sınırsız",
    totalExclTax: "Toplam (KDV hariç)",
    totalVat: "Toplam KDV",
    totalPayable: "Ödenecek Toplam",
    confirmCart: "Sepeti Onayla",
    loading: "Yükleniyor...",
  },
  en: {
    cart: "Cart",
    emptyCart: "Your cart is empty",
    remove: "Remove",
    monthlyCredit: "Credits / Month",
    ioCredit: "Outgoing and Incoming Invoice Credits",
    oCredit: "Outgoing Invoice Credits • Unlimited Incoming Invoices",
    totalExclTax: "Total (Excl. VAT)",
    totalVat: "Total VAT",
    totalPayable: "Total Payable",
    confirmCart: "Confirm Cart",
    loading: "Loading...",
  },
  de: {
    cart: "Warenkorb",
    emptyCart: "Ihr Warenkorb ist leer",
    remove: "Entfernen",
    monthlyCredit: "Kontingent / Monat",
    ioCredit: "Kontingent für ausgehende und eingehende Rechnungen",
    oCredit:
      "Kontingent für ausgehende Rechnungen • Eingehende Rechnungen unbegrenzt",
    totalExclTax: "Gesamt (ohne MwSt.)",
    totalVat: "MwSt. Gesamt",
    totalPayable: "Zu zahlender Gesamtbetrag",
    confirmCart: "Warenkorb bestätigen",
    loading: "Wird geladen...",
  },
  fr: {
    cart: "Panier",
    emptyCart: "Votre panier est vide",
    remove: "Supprimer",
    monthlyCredit: "Crédits / Mois",
    ioCredit: "Crédits pour factures entrantes et sortantes",
    oCredit:
      "Crédits pour factures sortantes • Factures entrantes illimitées",
    totalExclTax: "Total (Hors Taxes)",
    totalVat: "Total TVA",
    totalPayable: "Total à payer",
    confirmCart: "Confirmer le panier",
    loading: "Chargement...",
  },
  nl: {
    cart: "Winkelwagen",
    emptyCart: "Uw winkelwagen is leeg",
    remove: "Verwijderen",
    monthlyCredit: "Credits / Maand",
    ioCredit: "Credits voor inkomende en uitgaande facturen",
    oCredit:
      "Credits voor uitgaande facturen • Onbeperkte inkomende facturen",
    totalExclTax: "Totaal (excl. btw)",
    totalVat: "Totaal btw",
    totalPayable: "Totaal te betalen",
    confirmCart: "Winkelwagen bevestigen",
    loading: "Laden...",
  },
};

const CardPanel = ({
  cart,
  totalAmount,
  cartSummary,
  language = "tr",
  onChangeQuantity,
  mobile,
  onClose,
  onConfirmCart,
  confirmLoading = false,
  confirmError = "",     
}) => {
  const lang = String(language || "tr")
    .toLowerCase()
    .replace("_", "-")
    .trim()
    .slice(0, 2);

  const text = TEXTS[lang] || TEXTS.tr;

const getItemSubInfo = (item) => {
  const provisioning = item.provisioningSetting || {};
   const companyCount = Number(item.companyCount || item.quantity || 1);

  if (item.priceType === "Q") {
    const credit = provisioning.credit;

    return credit
      ? Number(credit).toLocaleString(lang === "tr" ? "tr-TR" : "en-US")
      : "";
  }

  if (item.priceType === "AM" || item.priceType === "AY") {
    const monthlyCredit = Number(provisioning.monthlyGiftCredit || 0);
    const totalCredit = monthlyCredit * companyCount;

    const creditText = monthlyCredit
      ? `${totalCredit} ${text.monthlyCredit}`
      : "";

    const typeText =
      provisioning.creditType === "O"
        ? text.oCredit
        : provisioning.creditType === "IO"
          ? text.ioCredit
          : "";

    const companyText =
      companyCount > 1 ? `${companyCount} Firma` : "";

    return [creditText, typeText, companyText].filter(Boolean).join(" • ");
  }

  return "";
};

  const getItemTotal = (item) => {
    return (
      Number(item.unitPrice || 0) *
      Number(item.multiplier || 1) *
      Number(item.quantity || 0)
    );
  };

  return (
    <div className="flex h-full flex-col overflow-hidden bg-white">
      <div className="flex items-center justify-between border-b border-slate-200 px-4 py-4">
        <h3 className="text-base font-semibold text-slate-800">{text.cart}</h3>

        {mobile && (
          <button
            type="button"
            onClick={onClose}
            className="inline-flex h-10 w-10 shrink-0 items-center justify-center rounded-full border border-slate-200 bg-white text-slate-600 hover:bg-slate-50"
          >
            <FiX size={18} />
          </button>
        )}
      </div>

      <div className="flex-1 overflow-y-auto bg-slate-50 p-3">
        {cart.length === 0 ? (
          <div className="rounded-xl border border-dashed border-slate-300 bg-white p-6 text-center text-sm text-slate-500">
            {text.emptyCart}
          </div>
        ) : (
          <div className="space-y-3">
            {cart.map((item) => {
              const isSubscription =
                item.priceType === "AM" || item.priceType === "AY";

              return (
                <div
                  key={item.code || item.id}
                  className="rounded-xl border border-slate-200 bg-white p-3 shadow-sm"
                >
                  <div className="line-clamp-2 text-sm font-semibold text-slate-800">
                    {item.name}
                  </div>

                  {getItemSubInfo(item) && (
                    <div className="mt-1 text-xs leading-4 text-slate-500">
                      {getItemSubInfo(item)}    
                    </div>
                  )}

                  <div className="mt-3 flex items-center justify-between gap-3">
                    {isSubscription ? (
                      <button
                        type="button"
                        onClick={() => onChangeQuantity(item, "decrease")}
                        className="rounded-lg border border-slate-300 px-3 py-1.5 text-xs font-semibold text-slate-600 hover:bg-slate-50"
                      >
                        {text.remove}
                      </button>
                    ) : (
                      <div className="flex items-center overflow-hidden rounded-lg border border-slate-300 bg-slate-100">
                        <button
                          type="button"
                          onClick={() => onChangeQuantity(item, "decrease")}
                          className="flex h-8 w-8 items-center justify-center font-bold hover:bg-slate-200"
                        >
                          -
                        </button>

                        <div className="w-10 border-x bg-white text-center">
                          {item.quantity}
                        </div>

                        <button
                          type="button"
                          onClick={() => onChangeQuantity(item, "increase")}
                          className="flex h-8 w-8 items-center justify-center font-bold hover:bg-slate-200"
                        >
                          +
                        </button>
                      </div>
                    )}

                    <div className="text-right">
                      <div className="text-sm font-bold text-slate-800">
                        {formatMoneyByLanguage(getItemTotal(item), lang)}
                      </div>

                      {/* <div className="text-[11px] text-slate-500">
                        {formatMoneyByLanguage(
                          Number(item.unitPrice || 0) *
                            Number(item.multiplier || 1),
                          lang
                        )}
                      </div> */}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>

      <div className="border-t border-slate-200 bg-white p-4">
        <div className="mb-3 rounded-xl bg-slate-100 px-3 py-3">
          <div className="flex items-center justify-between py-1">
            <span className="text-sm text-slate-600">{text.totalExclTax}</span>
            <span className="text-sm font-semibold">
              {formatMoneyByLanguage(cartSummary?.totalExclTax ?? 0, lang)}
            </span>
          </div>

          <div className="flex items-center justify-between border-t py-2">
            <span className="text-sm text-slate-600">{text.totalVat}</span>
            <span className="text-sm font-semibold">
              {formatMoneyByLanguage(cartSummary?.totalTax ?? 0, lang)}
            </span>
          </div>

          <div className="flex items-center justify-between border-t pt-2">
            <span className="text-sm font-semibold">{text.totalPayable}</span>

            <span className="text-base font-bold" style={{ color: MAIN_COLOR }}>
              {formatMoneyByLanguage(
                cartSummary?.totalToPay ?? totalAmount ?? 0,
                lang
              )}
            </span>
          </div>
        </div>

        {confirmError && (
          <div className="mb-3 rounded-lg border border-red-200 bg-red-50 px-3 py-2 text-xs text-red-700">
            {confirmError}
          </div>
        )}

        <button
          type="button"
          onClick={onConfirmCart}
          disabled={cart.length === 0 || confirmLoading}
          className="flex h-11 w-full items-center justify-center gap-2 rounded-xl font-semibold text-white disabled:opacity-50"
          style={{ backgroundColor: MAIN_COLOR }}
        >
          <FiCheckCircle size={18} />
          {confirmLoading ? text.loading : text.confirmCart}
        </button>
      </div>
    </div>
  );
};

export default CardPanel;